<template lang="pug">
ExamplePicker(v-model="example")

VButton(@click="toggleMode") {{ buttonTitle }}

template(v-if="isEdit")
	SchemaForm(:schema="schema", :errors="errors", v-model="object")
		template(#actions)
			| #actions content

template(v-else-if="isView")
	SchemaView(:schema="schema", :object="object")

KTextBox(
	variant="dark",
	fontSize="tiny",
	padding="1rem",
	title="object",
	v-model="object",
	@copy="this.$notify.event('Json data copied to clipboard!', 'success')",
	fontMono
)

KTextBox(
	variant="dark",
	fontSize="tiny",
	padding="1rem",
	title="prunedObject",
	v-model="prunedObject",
	@copy="this.$notify.event('Json data copied to clipboard!', 'success')",
	fontMono
)

KTextBox(
	variant="dark",
	fontSize="tiny",
	padding="1rem",
	style="--kcl-textbox-line-height: 1.2",
	title="schema",
	v-model="schema",
	@copy="this.$notify.event('Json data copied to clipboard!', 'success')",
	fontMono
)

KTextBox(
	variant="dark",
	fontSize="tiny",
	padding="1rem",
	style="--kcl-textbox-line-height: 1.2",
	title="errors",
	v-model="errors",
	@copy="this.$notify.event('Json data copied to clipboard!', 'success')",
	fontMono
)
</template>

<script>
import { createObject, pruneOptionalProperties } from "@/js/utils/json-schema";

import ExamplePicker from "./components/ExamplePicker.vue";
import {
	Form as SchemaForm,
	View as SchemaView
} from "@/components/base/JsonSchema/index";

import examples from "./examples/index";

export default {
	name: "StyleguideJsonSchemaForm",
	components: {
		ExamplePicker,
		SchemaForm,
		SchemaView
	},
	data() {
		return {
			mode: "edit",
			object: null
		};
	},
	computed: {
		example: {
			get() {
				return this.$route.query.example ?? "basic";
			},
			set(value) {
				this.$router.replace({
					query: {
						example: value
					}
				});
			}
		},
		errors() {
			return null;
		},
		buttonTitle() {
			if (this.isView) {
				return "Edit";
			}

			return "View";
		},
		schema() {
			return examples[this.example].schema;
		},
		exampleObject() {
			const blank = false;
			if (blank) {
				return {};
			}

			return examples[this.example].object;
		},
		prunedObject() {
			return pruneOptionalProperties(this.schema, this.object);
		},
		isEdit() {
			return this.mode === "edit";
		},
		isView() {
			return this.mode === "view";
		}
	},
	watch: {
		schema: {
			handler() {
				this.object = createObject(this.schema, this.exampleObject);
			},
			immediate: true
		}
	},
	methods: {
		toggleMode() {
			if (this.isView) {
				this.mode = "edit";
			} else {
				this.mode = "view";
			}
		}
	}
};
</script>
